<template>
  <div>
    <filled :id="parseInt($route.params.id, 10) " :userId="$route.params.userId" :printable="true" :printMode="0"></filled>
  </div>
</template>
<script>
import filled from "@/components/modules/form/filled/index.vue";

export default {
  components: {
    filled,
  },
  mounted() {
    //this.$router.push({name: 'learningHome' });
  },
};
</script>
